/**
 * API variables
 */
export const API_URL = '/database/api.php/'
export const ENDPOINT_VISU_EXHIBITION = 'visu_exhibition'
export const ENDPOINT_VISU_EXHIBITION_SECTION = 'visu_exhibition_section'
export const ENDPOINT_VISU_EXHIBITION_SECTION_CSV = 'visu_csv_sections'
export const ENDPOINT_VISU_EXHIBITION_ADDRESS = 'visu_exhibition_address'
export const ENDPOINT_VISU_EXHIBITOR = 'visu_exhibitor'
export const ENDPOINT_VISU_EXHIBITED_WORK = 'visu_exhibited_work'
export const ENDPOINT_VISU_EXHIBITED_WORK_CSV = 'visu_csv_exhibited_work'
export const ENDPOINT_VISU_EXHIBITION_GROUP_TYPE = 'visu_exhibition_group_type'
export const ENDPOINT_VISU_EXHIBITION_GROUP = 'visu_exhibition_group'
export const ENDPOINT_VISU_EXHIBITION_CATALOG = 'visu_exhibition_catalog'
export const ENDPOINT_COUNTRIES = 'visu_country'



// WEBPACK FOOTER //
// ./src/config.js